<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <v-breadcrumbs>
            <v-breadcrumbs-item>
              <router-link to="/">Home</router-link>
            </v-breadcrumbs-item>
            <span class="divider">></span>
            <v-breadcrumbs-item disabled>
              Parking Booth Location
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-col>
      </v-row>

      <v-row no-gutters class="px-2 px-md-5">
        <v-col cols="12">
            <h1 class="mb-4">Parking Booth Location</h1>
          
            <!-- Centered Image -->
            <v-row justify="center" class="mb-6">
                <v-col cols="12" md="8" lg="6">
                    <v-img src="@/assets/parking-booth.jpeg" class="mb-4" contain max-height="800"></v-img>
                </v-col>
            </v-row>

            <!-- Tables Row - Responsive -->
            <v-row>
                <!-- Zone 1 Table -->
                <v-col cols="12" md="4">
                    <v-card class="pa-4 mb-4">
                        <v-table density="compact">
                            <thead>
                                <tr>
                                    <th colspan="2" class="text-center font-weight-bold">Zone 1</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Pondok A</td>
                                    <td>Tamu Muhibbah</td>
                                </tr>
                                <tr>
                                    <td>Pondok B</td>
                                    <td>CPA No. 3</td>
                                </tr>
                                <tr>
                                    <td>Pondok C</td>
                                    <td>Jalan Brooke</td>
                                </tr>
                                <tr>
                                    <td>Pondok D</td>
                                    <td>Nahkoda Gampar</td>
                                </tr>
                                <tr>
                                    <td>Pondok M</td>
                                    <td>Morsjaya</td>
                                </tr>
                                <tr>
                                    <td>Pondok N</td>
                                    <td>King's Centre</td>
                                </tr>
                            </tbody>
                        </v-table>
                    </v-card>
                </v-col>

                <!-- Zone 2 Table (First) -->
                <v-col cols="12" md="4">
                    <v-card class="pa-4 mb-4">
                        <v-table density="compact">
                            <thead>
                                <tr>
                                    <th colspan="2" class="text-center font-weight-bold">Zone 2</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Pondok E</td>
                                    <td>Waterfront</td>
                                </tr>
                                <tr>
                                    <td>Pondok F</td>
                                    <td>Jalan Tritonia</td>
                                </tr>
                                <tr>
                                    <td>Pondok G</td>
                                    <td>Jalan Pos</td>
                                </tr>
                                <tr>
                                    <td>Pondok H</td>
                                    <td>Jalan Bintang</td>
                                </tr>
                            </tbody>
                        </v-table>
                    </v-card>
                </v-col>

                <!-- Zone 2 Table (Second) -->
                <v-col cols="12" md="4">
                    <v-card class="pa-4 mb-4">
                        <v-table density="compact">
                            <thead>
                                <tr>
                                    <th colspan="2" class="text-center font-weight-bold">Zone 2 (Continued)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Pondok I</td>
                                    <td>Lorong 10</td>
                                </tr>
                                <tr>
                                    <td>Pondok J</td>
                                    <td>Pelita</td>
                                </tr>
                                <tr>
                                    <td>Pondok K</td>
                                    <td>Boulevard</td>
                                </tr>
                                <tr>
                                    <td>Pondok L</td>
                                    <td>Taman Yakin</td>
                                </tr>
                                <tr>
                                    <td>Pondok P</td>
                                    <td>Saberkas</td>
                                </tr>
                            </tbody>
                        </v-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'FindBPSBoothPage'
};
</script>
